<template>
  <div class="ui large modal" ref="modal">
    <div class="ui icon header">
      <i class="upload icon"></i>
      {{ $t("upload file") }}
    </div>
    <div class="scrolling content">
      <input type="file" @change="onChange" />
      <table class="ui striped celled selectable compact table" ref="table">
        <thead>
          <tr>
            <th>{{ $t("code") }}</th>
            <th>{{ $t("comment") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in file_content" :key="index">
            <td data-label="Name">{{ row[0] }}</td>
            <td data-label="Name">{{ row[1] }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="actions">
      <div class="ui red cancel button">
        <i class="remove icon"></i>
        {{ $t("cancel") }}
      </div>
      <div class="ui green button" @click="ok">
        <i class="checkmark icon"></i>
        {{ $t("ok") }}
      </div>
    </div>
  </div>
</template>

<script>
import {
  local_api,
  api_host,
  enterprise_setup,
  init_json_local_data_datables,
  error_toast,
} from "@/utils";
import filters from "@/filters";
import readXlsxFile from "read-excel-file";

// import GraphicCards from "./GraphicCards";

export default {
  name: "NvidiaBundleUploadCodesModal",
  filters: filters,
  components: {},
  computed: {
    token_session() {
      let token = this.$session.get("token");
      return token;
    },
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  props: {
    selected_store: Object,
  },
  data() {
    return {
      api_host: api_host,
      file: null,
      file_content: [],
      bundle: {},
    };
  },
  methods: {
    hide() {
      let vm = this;
      window.jQuery(vm.$refs.modal).modal("hide");
    },
    show(bundle) {
      let vm = this;
      vm.bundle = bundle;
      window
        .jQuery(vm.$refs.modal)
        .modal({
          allowMultiple: true,
          onHidden: () => {
            vm.file = null;
            vm.file_content = [];
          },
        })
        .modal("show");
    },
    onChange(event) {
      let vm = this;
      vm.file = event.target.files ? event.target.files[0] : null;
      readXlsxFile(vm.file)
        .then((rows) => {
          vm.file_content = rows;

          let columns = [
            {
              data: function(row) {
                // console.log(row);
                return row[0];
              },
            },
            {
              data: function(row) {
                return row[1];
              },
            },
          ];
          init_json_local_data_datables(vm, vm.$refs.table, rows, columns);
        })
        .catch((err) => {
          console.error(err);
        });
    },
    ok() {
      let vm = this;

      local_api(this, "post", "/nvidia_bundle/bundle/do-upload-codes", {
        bundle: vm.bundle.bundle_id,
        data: vm.file_content,
      })
        .then(() => {
          vm.hide();
        })
        .catch((err) => {
          error_toast(err);
        });
    },
  },
  mounted() {
    // let vm = this;
  },
  watch: {},
  updated: function() {},
};
</script>
